export default __webpack_public_path__ + "static/media/uranus.0b53589e.jpg";